import {Injectable} from '@angular/core';
import {CustomHttp, ApiConstants} from '../shared';
import {Http, Headers, RequestOptions} from '@angular/http';
import * as _ from 'lodash';

@Injectable()
export class BulkInfohashService {
    private PENDING_BULK_INFOHASH = 'datahealth/cumulative_torrents/pending';
    private BULK_INFOHASH_URL = 'datahealth/cumulative_torrents';

    private INFOHASH_SEARCH_URL_V2 = '/cumulative_torrents/v2/datahealth/';


    private INFOHASH_SEARCH_BY_TERM_QUERY = {
        'search_by': '',
        'search_term': '',
        'order_by': '',
        'order_direction': '',
        'page': '',
        'size': ''
    };

    private GET_ALL_INFOHASH_QUERY = {
        'start_date': '',
        'end_date': '',
        'human_verified': '',
        'system_verified': '',
        'smart_grouping': '',
        'order_by': '',
        'order_direction': '',
        'size': '',
        'page': '',
        'category': '',
        'parrot_only': ''
    };

    private INFOHASH_UPDATE_QUERY = [
        {
            'infohash': '',
            'properties': ''
        }
    ];

    constructor(private http: Http, private customHttp: CustomHttp, private apiConstants: ApiConstants) {
    }


    // tslint:disable-next-line:max-line-length
    createAllInfohashSearchRequest(startDate: any, endDate: any, orderBy: string, orderDirection: string, page: any, pageSize: any, categoryType: any, humanVerfiedCheckBox: any, systemVerfiedCheckBox: any, smartGroupingCheckBox: boolean, parrotOnly: any, demandSupplyOnly)
    // tslint:disable-next-line:one-line
    {
        const request = _.cloneDeep(this.GET_ALL_INFOHASH_QUERY);

        startDate = startDate.toISOString().slice(0, 10);
        endDate = endDate.toISOString().slice(0, 10);

        request.start_date = startDate;
        request.end_date = endDate;
        request.human_verified = humanVerfiedCheckBox;
        request.system_verified = systemVerfiedCheckBox;
        request.order_by = orderBy;
        request.order_direction = orderDirection;
        request.size = pageSize;
        request.page = page;
        request.category = categoryType;
        request.smart_grouping = smartGroupingCheckBox;
        request.parrot_only = parrotOnly;
        request.demand_only = demandSupplyOnly;


        //console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }


    createSearchRequest(searchBy: string, searchTerm: string, page: any, pageSize: any, orderBy: string, orderDirection: string) {
        const request = _.cloneDeep(this.INFOHASH_SEARCH_BY_TERM_QUERY);
        request.search_by = searchBy;
        request.search_term = searchTerm;
        request.page = page;
        request.size = pageSize;
        request.order_by = orderBy;
        request.order_direction = orderDirection;

        // console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    createUpdateInfohashRequest(infohash: string, properties: string) {
        const request = _.cloneDeep(this.INFOHASH_UPDATE_QUERY);
        // properties = JSON.stringify(properties);
        // console.log(properties);
        // console.log(infohash);
        request[0].infohash = infohash;
        request[0].properties = properties;

        // console.log(JSON.stringify(request));
        return JSON.stringify(request);
    }

    updateInfohash(propertiesArray: any, searchUrlTerm: any) {
        const url = `${this.getHelpdeskBaseUrl()}${this.INFOHASH_SEARCH_URL_V2}${searchUrlTerm}`;
        let headers = new Headers();
        headers = this.createAuthorizationHeader(headers);
        // const payload = this.createUpdateInfohashRequest(infohash, propertiesArray);
        const payload = JSON.stringify(propertiesArray);
        // console.log(payload);
        return this.http.post(url, payload, {headers: headers})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }


    getInfohashBySearchTerm(searchBy: string, searchTerm: string, page: any, pageSize: any, searchUrlTerm: string, orderBy: string, orderDirection: string) {
        const url = `${this.getHelpdeskBaseUrl()}${this.INFOHASH_SEARCH_URL_V2}${searchUrlTerm}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);

        const payload = this.createSearchRequest(searchBy, searchTerm, page, pageSize, orderBy, orderDirection);

        return this.http.post(url, payload, {headers: headers})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }

    // tslint:disable-next-line:max-line-length
    getAllInfoHash(startDate: any, endDate: any, orderBy: string, orderDirection: string, page: any, pageSize: any, categoryType: any, searchUrlTerm: string, humanVerfiedCheckBox: any, systemVerfiedCheckBox: any, smartGroupingCheckBox: boolean, parrotOnly: any, demandSupplyOnly) {
        // console.log(parrotOnly)

        if(!smartGroupingCheckBox){
            if(orderBy == 'trackedOn'){
                orderBy = 'tracked_on';
            }else if(orderBy == 'hygieneTitle')
            {
                orderBy = 'hygiene_title';

            }else if(orderBy == 'parrotId'){
                orderBy = 'parrot_id';

            }else if(orderBy == 'discoveryTime'){
                orderBy = 'discovery_time';

            }else if(orderBy == 'cumulativeTotalRecords'){
                orderBy = 'cumulative_total_records';

            }else if(orderBy == 'seedersAndLeechers'){
                orderBy = 'seeders_leechers';

            }
        }

        const url = `${this.getHelpdeskBaseUrl()}${this.INFOHASH_SEARCH_URL_V2}${searchUrlTerm}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        // tslint:disable-next-line:max-line-length
        const payload = this.createAllInfohashSearchRequest(startDate, endDate, orderBy, orderDirection, page, pageSize, categoryType, humanVerfiedCheckBox, systemVerfiedCheckBox, smartGroupingCheckBox, parrotOnly, demandSupplyOnly);

        //console.log(payload)

        return this.http.post(url, payload, {headers: headers})
            .map(res => res.json())
            .toPromise()
            .catch(error => console.log(error));
    }


    getBulkInfohash(username: string, dailyCheck: boolean, dateRangeItem: string, startDate: Date, endDate: Date,
                    orderBy: string, orderDirection: string, size: number = 100, page: number = 0, parrotIds: string[],
                    query?: string, queryType?: 'exact' | 'like', all?: boolean) {
        const startDateString = startDate.toISOString().slice(0, 10);
        const endDateString = endDate.toISOString().slice(0, 10);
        // Do not allow query type to be sent if there is no query
        if (!query || query === '') {
            queryType = null;
        }
        const url = `${this.getBaseUrl()}${this.BULK_INFOHASH_URL}?size=${size}&page=${page}` +
            `&username=${encodeURIComponent(username)}${
                dailyCheck ? '&daily_check=' + dailyCheck : ''}${
                dateRangeItem ? '&date_range_item=' + dateRangeItem : ''}${
                startDate ? '&start_date=' + startDateString : ''}${
                endDate ? '&end_date=' + endDateString : ''}${
                orderBy ? '&order_by=' + orderBy : ''}${
                orderDirection ? '&order_direction=' + orderDirection : ''}${
                parrotIds.length > 0 ? '&parrot_ids=' + parrotIds.join(',') : ''}${
                query && !dailyCheck ? '&query=' + query : ''}${queryType && !dailyCheck ? '&query_type=' + queryType : ''}${
                all ? '&all=' + all : ''}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {headers: headers, body: ''})
            .map(res => res.json())
            .toPromise();
    }

    getInfohashBatch(user: string) {
        const url = `${this.getBaseUrl()}${this.BULK_INFOHASH_URL}/batch?user=${user}`;
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        return this.http.get(url, {headers: headers})
            .map(res => res.json())
            .toPromise();
    }

    getPendingInfohashBatch(user: string) {
        const uri = `/cumulative_torrents/batch?user=${user}`;
        return this.customHttp.get(uri);
    }


    getPendingInfohashMappings(size = 100, page = 0, orderBy: string, orderDirection: string) {
        const uri = `/cumulative_torrents/pending-mapping?size=${size}&page=${page}` +
            `${orderBy ? '&order_by=' + orderBy : ''}${orderDirection ? '&order_direction=' + orderDirection : ''}`;
        return this.customHttp.get(uri);
    }

    getPendingCumulativeTorrents(infohashes: String[]) {
        const url = `${this.getBaseUrl()}${this.PENDING_BULK_INFOHASH}`;
        const headers = new Headers();
        this.createAuthorizationHeader(headers);
        return this.http.post(url, JSON.stringify(infohashes), {headers: headers})
            .map(res => res.json())
            .toPromise();
    }

    postUpdateMappings(mappings: any[], user: string) {
        return this.customHttp.post(`/cumulative_torrents/update-mapping${user ? '?user=' + user : ''}`, mappings);
    }

    postProcessMappings(mappings: any[], user: string) {
        return this.customHttp.post(`/cumulative_torrents/process-mapping${user ? '?user=' + user : ''}`, mappings);
    }

    createAuthorizationHeader(headers: Headers) {
        headers.append('x-auth-token', localStorage.getItem('id_token'));
        headers.append('Content-Type', 'application/json');
        return headers;
    }

    getBaseUrl() {
        return this.apiConstants.CATALOG_API_URL;
    }

    getHelpdeskBaseUrl() {
        return this.apiConstants.HELPDESK_API_URL;
    }

}



// WEBPACK FOOTER //
// ./src/app/bulk-infohash/bulk-infohash.service.ts